module.exports = __webpack_public_path__ + "static/Testimonial2-ef3354da3c44ca9c2021a1ac6904b62d.jpg";